import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faCheck, faEdit, faEraser, faRedo, faRedoAlt, faTrash, faDirections, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlus, faCheck, faEdit, faEraser, faRedo, faRedoAlt, faTrash, faDirections, faSave, faTrashAlt);

Vue.component('fa-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Mapbox
window.mapboxgl = require('mapbox-gl');

import VueFire from 'vuefire';
Vue.use(VueFire)

new Vue({
  render: h => h(App)
}).$mount('#app')
